<section class="section-landing-hero" *ngIf="getStartedDesign">
  <div class="container align-c">
    <div class="landing-hero-content-box">
      <div style="display: none">Test</div>
      <h1 class="landing-hero-header mar-b-32">
        {{ whiteTitle }} <span class="moonstone">{{ coloredTitle }}</span>
      </h1>
      <div class="landing-hero-content mar-b-24" [innerHtml]="getStartedDesign.content | toHtml"></div>
      <div class="landing-btn">
        <a
          href="{{ getStartedDesign?.buttons[0].fields.redirectLink | urlParams:queryParams }}"
          target="{{ getStartedDesign?.buttons[0]?.fields?.actionType }}" 
          class="btn btn-full"
          (click)="onHomepageHeroCTAClick()">
          {{ getStartedDesign?.buttons[0].fields.buttonText }}
        </a>
        <app-common-talktosales-button
          [text]="getStartedDesign?.buttons[1]?.fields?.buttonText"></app-common-talktosales-button>
      </div>
    </div>
    <img *ngIf="imageSrc" [loaderParams]="{ compression: 50 }" priority height="434" width="1440" class="landing-img"
      alt="Cross Border payments infrastructure" ngSrc="{{ imageSrc }}" />
  </div>
</section>

<!-- @defer(hydrate on idle){ -->
  <!-- Trusted way section -->
  <section class="section" *ngIf="trustedWaySectionData">
    <div class="section-container">
      <h2 class="section-heading mar-b-32">
        {{ trustedWaySectionData?.header }}
      </h2>
      <div class="section-description">
        <div class="wid-75" [innerHtml]="trustedWaySectionData.description | toHtml"></div>
      </div>
      <div class="section-customer-logos">
        <figure class="customer-logos" *ngFor="let testimonial of trustedWaySectionData.testimonials">
          <img loading="lazy" [src]="protocol + testimonial?.fields?.image?.fields?.file?.url"
            alt="{{ testimonial?.fields?.image?.fields?.description || testimonial?.fields?.image?.fields?.title }}"
            [ngClass]="
              protocol +
              testimonial?.fields?.image?.fields?.file?.url.includes(
                'customer-logos-02'
              )
                ? 'no-brightness-opacity'
                : ''
            " />
        </figure>
      </div>
      <app-trust-pilot
        [bgWhite]="false"
        [paddTop]="true"
      ></app-trust-pilot>
    </div>
  </section>

  <!-- Unified solution section -->
  <section class="section white-100 unified-section" *ngIf="unifiedSolutionsData">
    <div class="section-container">
      <h2 class="section-heading mar-b-32" [innerHTML]="highlightedTextUnified"></h2>
      <p class="section-description mar-b-48 align-c">
        <span class="wid-75">{{ unifiedSolutionsData?.description }}</span>
      </p>
      <div class="section-product-landing">
        <div class="product-landing" *ngFor="let card of unifiedSolutionsData?.cards">
          <a [href]="card?.fields?.link" class="card-link" 
             (click)="onUnifiedSolutionsCardClick(card?.fields?.richTextTitle?.content[0]?.content[0]?.value, card?.fields?.link)">
            <div class="product-landing-content">
              <h5 class="product-landing-heading">
                <!-- {{ card?.fields?.richTextTitle?.content[0]?.content[0]?.value }} -->
                <div [innerHtml]="card?.fields?.richTextTitle | toHtml"></div>
                <img fetchpriority="low" loading="lazy" class="mar-l-8 heading-link-arrow-icon" alt="arrow"
                  [src]="card?.fields?.button[0]?.fields?.icon?.fields?.file?.url" />
              </h5>
              <div class="product-landing-description" [innerHtml]="card?.fields?.description | toHtml"></div>
            </div>
            <figure>
              <img fetchpriority="low" loading="lazy" src="{{ card?.fields?.imageicon?.fields?.file?.url }}"
                alt="{{ card?.fields?.imageicon?.fields?.title }}" class="product-landing-img" />
            </figure>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Globe section -->
  <section class="section grey-900 over-hidden payment-ecosystem-wrapper" *ngIf="getWay">
    <div class="section-container z-index-1">
      <h2 class="section-heading-l mar-b-32 white wid-50">
        {{ getWay.title }}
      </h2>
      <p class="section-description-l mar-b-48 white wid-75">
        <span class="wid-75 align-l">{{
          getWay.content.content[0].content[0].value
          }}</span>
      </p>
      <div class="section-global-ecosystem wid-50">
        <div class="global-ecosystem" *ngFor="let item of getWay.component1">
          <div class="global-ecosystem-value">
            <span class="global-ecosystem-border"></span>
            <span class="global-ecosystem-value">{{
              item.fields.richTextTitle.content[0].content[0].value
              }}</span>
          </div>
          <p class="global-ecosystem-content">
            {{ item.fields.description.content[0].content[0].value }}
          </p>
        </div>
      </div>
    </div>
    <div class="global-ecosystem-image globe-inner-wrapper">
      <img loading="lazy" class="globe-canvas" [src]="getWay.image?.[0]?.fields?.file?.url" alt="Globe Canvas">
    </div>
  </section>

  <!-- financial soltion section -->
  <section class="section white-100 financial-section" *ngIf="financialSolData">
    <div class="section-container-inside">
      <h2 class="section-heading mar-b-48">
        <span class="wid-75">{{ financialSolData?.header }}</span>
      </h2>
      <div class="section-business">
        <!------------ Startups ------------>
        <div class="business-container" *ngFor="let card of financialSolData?.title">
          <figure class="startups">
            <img loading="lazy" src="{{ card.fields.imageicon.fields.file.url }}"
              alt="{{ card.fields.imageicon.fields.title }}" class="product-landing-img" />
          </figure>
          <div class="business-container-content">
            <h5 class="business-container-heading">
              {{ card?.fields?.richTextTitle?.content[0]?.content[0].value }}
            </h5>
            <div class="business-container-description" [innerHtml]="card.fields.description | toHtml"></div>
            <a class="link mar-t-a hide" 
              href="{{ card.fields?.button[0].fields.redirectLink | urlParams:queryParams }}"
              target="{{ card.fields?.button[0].fields.actionType }}">
              {{ card.fields?.button[0].fields.buttonText }}
              <span class="font-size-m arrow">&rarr;</span>
            </a>
          </div>
          <a
            href="{{ card.fields?.button[0].fields.redirectLink | urlParams:queryParams }}"
            class="link-xl mar-t-a show" 
            target="{{ card.fields?.button[0].fields.actionType }}">
            {{ card.fields?.button[0].fields.buttonText }}
            <span class="font-size-m arrow">&rarr;</span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <app-common-borderless [borderlessData]="borderlessData"></app-common-borderless>

  <!-- Regulated section  -->
  <section class="section white-100" *ngIf="regulated">
    <div class="section-container-inside">
      <h2 class="section-heading mar-b-32">{{ regulated.title }}</h2>
      <p class="section-description">
        <span class="wid-75 mar-b-24">{{
          regulated.content.content[0].content[0].value
          }}</span>
      </p>
      <div class="mar-b-48 display-f justfy-c">
        <a class="btn btn-full" href="{{ regulated.buttons[0]?.fields?.redirectLink }}" target="_self">{{ regulated.buttons[0]?.fields?.buttonText }}</a></div>
      <div class="section-regulated-excellence">
        <div class="regulated-excellence" *ngFor="let item of regulated.component1">
          <img class="regulated-flags" [src]="item.fields?.imageicon.fields.file.url" alt="" loading="lazy" />
          <div class="regulated-excellence-heading">
            {{ item.fields?.subTitle }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Trusted by section -->
  <section class="section white-100" *ngIf="discoverPanelData">
    <div class="section-container-inside align-c">
      <h2 class="section-heading mar-b-48">
        {{ discoverPanelData.title }}
      </h2>
      <div class="tabs-light">
        <!----- Target Mart ----->
        <ng-container *ngFor="let tab of discoverPanelData.components">
          <label [class.active]="tab?.active" [attr.id]="tab.id + '-tab'" data-bs-toggle="tab"
            [attr.data-bs-target]="'#' + tab.id" type="button" role="tab" [attr.aria-controls]="tab?.id"
            [attr.aria-selected]="tab?.active ? 'true' : 'false'" (click)="selectTab(tab)">{{ tab?.fields?.title
            }}</label>
        </ng-container>
        <div class="tab-light" [class.show]="tab.active" [class.active]="tab.active"
          *ngFor="let tab of discoverPanelData.components" [attr.id]="tab?.id" role="tabpanel"
          [attr.aria-labelledby]="tab.id + '-tab'">
          <div class="trusted-innovators">
            <div class="align-l">
              <div class="trusted-innovators-content">
                {{ tab?.fields?.description?.content[0]?.content[0]?.value }}
              </div>
              <div class="mar-t-24">
                <a class="link-xl" href="{{ tab?.fields?.button[0]?.fields?.redirectLink }}"
                  target="{{ tab?.fields?.button[0]?.fields?.actionType }}"
                  (click)="onTestimonialCaseStudyClick(tab?.fields?.title, tab?.fields?.button[0]?.fields?.redirectLink)">
                  {{ tab?.fields?.button[0]?.fields?.buttonText }}
                  <span class="arrow">&rarr;</span>
                </a>
              </div>
            </div>
            <figure class="trusted-innovators-image">
              <img [src]="tab?.fields?.image?.fields?.file?.url" alt="" loading="lazy" />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Trustpilot section -->
  <app-trust-pilot
    [bgWhite]="true"
    [paddTop]="true"
  ></app-trust-pilot>


  <!-- Security section -->
  <section id="security" class="section white-100" *ngIf="security">
    <div class="section-container-inside">
      <h2 class="section-heading mar-b-48">
        {{ security?.title }}
      </h2>
      <div class="security-compliance grey-100">
        <div class="security-compliance-content">
          <div *ngFor="let item of security.component1">
            <img [src]="item.fields.imageicon.fields.file.url" alt="" loading="lazy" />
            <div class="security-compliance-heading">
              {{ item.fields.richTextTitle.content[0].content[0].value }}
            </div>
            <p class="security-compliance-description">
              {{ item.fields.description.content[0].content[0].value }}
            </p>
          </div>
        </div>
        <div class="security-compliance-badges">
          <ng-container *ngFor="let item of security.image">
            <img [src]="item.fields.file.url" alt="" loading="lazy" />
          </ng-container>
        </div>
      </div>
    </div>
  </section>

  <!-- Discover section -->
  <section class="section white-100" *ngIf="startPanel">
    <div class="section-container white-100">
      <div class="section-discover-power">
        <div class="discover-power-content">
          <div class="discover-power-heading" [innerHTML]="highlightedText"></div>
          <div class="landing-btn">
            <a
              href="{{ startPanel?.buttons[0].fields.redirectLink | urlParams:queryParams }}"
              target="{{ startPanel?.buttons[0].fields.actionType }}" 
              class="btn btn-full"
              (click)="onStartPanelCTAClick()">
              {{ startPanel?.buttons[0].fields.buttonText }}
            </a>
            <app-common-talktosales-button
              [text]="startPanel?.buttons[1]?.fields?.buttonText"></app-common-talktosales-button>
          </div>
        </div>
        <div class="discover-power-image">
          <img loading="lazy" [src]="startPanel?.image[0]?.fields?.file?.url" alt="" />
        </div>
      </div>
    </div>
  </section>

  <app-common-latest-news [blogData]="blogData"></app-common-latest-news>
<!-- } -->